/**
 * Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 04/05/2017.
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import reduxStore from './services/redux/redux'

import './css/index.css';
import './css/font-awesome.min.css';
import './css/flex.css';

import AppRoot from './app'

const container = document.getElementById('root');

ReactDOM.render(
    (
        <Provider store={reduxStore}>
            <AppRoot  />
        </Provider>
    ), container);




// WEBPACK FOOTER //
// ./src/index.js